import React from "react";

interface LogoProps {
  color?: string;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ color, className }) => {
  return (
    <svg
      width={36}
      height={36}
      viewBox={`0 0 36 36`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M29.0842 12.5509H24.301C24.0719 12.5509 23.8521 12.4598 23.6901 12.2978C23.528 12.1358 23.437 11.916 23.437 11.6868V6.96123C23.437 6.73208 23.528 6.51232 23.6901 6.35029C23.8521 6.18826 24.0719 6.09723 24.301 6.09723H26.1778C28.2598 6.09723 29.9482 7.78443 29.9482 9.86644V11.6868C29.9482 11.916 29.8572 12.1358 29.6951 12.2978C29.5331 12.4598 29.3134 12.5509 29.0842 12.5509Z"
        fill={color ?? "currentColor"}
      />
      <path
        d="M6.0625 26.1516V15.6012C6.0625 15.4877 6.08485 15.3754 6.12827 15.2705C6.17169 15.1657 6.23533 15.0705 6.31556 14.9902C6.39579 14.91 6.49104 14.8464 6.59586 14.803C6.70069 14.7595 6.81304 14.7372 6.9265 14.7372H11.6833C11.9124 14.7372 12.1322 14.8282 12.2942 14.9902C12.4563 15.1523 12.5473 15.372 12.5473 15.6012V29.058C12.5473 29.2871 12.4563 29.5069 12.2942 29.6689C12.1322 29.831 11.9124 29.922 11.6833 29.922H9.8329C7.7509 29.922 6.0625 28.2336 6.0625 26.1516Z"
        fill={color ?? "currentColor"}
      />
      <path
        d="M14.748 26.1516V15.6012C14.748 15.372 14.8391 15.1523 15.0011 14.9902C15.1631 14.8282 15.3829 14.7372 15.612 14.7372H20.3688C20.598 14.7372 20.8178 14.8282 20.9798 14.9902C21.1418 15.1523 21.2328 15.372 21.2328 15.6012V29.058C21.2328 29.2871 21.1418 29.5069 20.9798 29.6689C20.8178 29.831 20.598 29.922 20.3688 29.922H18.5184C16.4364 29.922 14.748 28.2336 14.748 26.1516Z"
        fill={color ?? "currentColor"}
      />
      <path
        d="M23.4336 26.1516V15.6012C23.4336 15.372 23.5246 15.1523 23.6866 14.9902C23.8487 14.8282 24.0684 14.7372 24.2976 14.7372H29.0543C29.2835 14.7372 29.5032 14.8282 29.6652 14.9902C29.8273 15.1523 29.9183 15.372 29.9183 15.6012V29.058C29.9183 29.2871 29.8273 29.5069 29.6652 29.6689C29.5032 29.831 29.2835 29.922 29.0543 29.922H27.2039C25.122 29.922 23.4336 28.2336 23.4336 26.1516Z"
        fill={color ?? "currentColor"}
      />
      <path
        d="M17.5417 6.0876L6.91816 6.078C6.68922 6.078 6.46964 6.16887 6.30764 6.33064C6.14565 6.49241 6.05448 6.71186 6.05416 6.9408L6.05176 8.838C6.05056 10.8768 7.70176 12.5328 9.74175 12.534L20.3653 12.5448C20.5946 12.5448 20.8145 12.4538 20.9767 12.2918C21.1389 12.1298 21.2302 11.9101 21.2305 11.6808V9.7848C21.2341 7.7448 19.5817 6.09 17.5417 6.0876Z"
        fill={color ?? "currentColor"}
      />
    </svg>
  );
};
